import React from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

// Styled component for the table container

// Reusable task table header component
export const TaskTableHeader = () => (
  <TableHead>
    <TableRow>
      <TableCell width="5%">{''}</TableCell>
      <TableCell width="24%">Task</TableCell>
      <TableCell width="20%">Assignee</TableCell>
      <TableCell width="18%">Priority</TableCell>
      <TableCell width="18%">Due Date</TableCell>
      <TableCell width="15%">{''}</TableCell>
    </TableRow>
  </TableHead>
);

// Interface for TaskTable props
export interface TaskTableProps {
  tasks: Array<Record<string, unknown>>;
  renderRow: (task: Record<string, unknown>) => JSX.Element;
  headerType?: 'core' | 'additional';
}

// Reusable component for task tables
export const TaskTable = ({
  tasks,
  renderRow,
  headerType = 'core',
}: TaskTableProps) => (
  <Box>
    <TableContainer
      component={Paper}
      className="new-customized-table-container"
      sx={{
        maxHeight: undefined,
        width: '100%',
        minWidth: '1200px',
        overflowX: 'auto',
      }}
    >
      <Table aria-label="customized table">
        <TableHead
          className="new-customized-table-head"
          sx={{
            '&.MuiTableCell-root.MuiTableCell-head.MuiTableCell-sizeMedium': {
              backgroundColor: 'none !important',
            },
          }}
        >
          <TableRow>
            <TableCell colSpan={6} className="new-customized-table-header-cell">
              <Box
                className="new-customized-table-header-row-container"
                sx={{
                  display: 'flex',
                  flexWrap: { xs: 'wrap', md: 'nowrap' },
                  gap: { xs: 1, md: 2 },
                }}
              >
                <Box
                  className="new-customized-table-header-column"
                  sx={{ width: '1px', flexShrink: 0, textAlign: 'left' }}
                >
                  TASK
                </Box>
                <Box
                  className="new-customized-table-header-column"
                  sx={{
                    width:
                      headerType === 'core'
                        ? { xs: '100%', sm: '19%', md: '17%', lg: '17.5%' }
                        : { xs: '100%', sm: '14%', md: '12%', lg: '11%' },
                    flexShrink: 0,
                    textAlign: 'left',
                  }}
                >
                  {/* Empty for task name */}
                </Box>
                <Box
                  className="new-customized-table-header-column"
                  sx={{
                    width:
                      headerType === 'core'
                        ? { xs: '100%', sm: '15%', md: '13%', lg: '11%' }
                        : { xs: '100%', sm: '15.5%', md: '13.5%', lg: '11.5%' },
                    flexShrink: 0,
                    textAlign: 'left',
                  }}
                >
                  ASSIGNEE
                </Box>
                <Box
                  className="new-customized-table-header-column"
                  sx={{
                    width:
                      headerType === 'core'
                        ? { xs: '100%', sm: '15%', md: '13%', lg: '10.5%' }
                        : { xs: '100%', sm: '15.5%', md: '13.5%', lg: '11.3%' },
                    flexShrink: 0,
                    textAlign: 'left',
                  }}
                >
                  PRIORITY
                </Box>
                <Box
                  className="new-customized-table-header-column"
                  sx={{
                    width:
                      headerType === 'core'
                        ? { xs: '100%', sm: '15.5%', md: '13.5%', lg: '11.5%' }
                        : { xs: '100%', sm: '15.5%', md: '13.5%', lg: '11.8%' },
                    flexShrink: 0,
                    textAlign: 'left',
                  }}
                >
                  DUE DATE
                </Box>
                <Box
                  className="new-customized-table-header-column"
                  sx={{
                    width:
                      headerType === 'core'
                        ? { xs: '100%', sm: '40%', md: '35%', lg: '30%' }
                        : { xs: '100%', sm: '38%', md: '33%', lg: '32%' },
                    flexShrink: 0,
                    textAlign: 'left',
                  }}
                >
                  COMPLETED ON
                </Box>
              </Box>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tasks.map((task, index) => (
            <TableRow key={task['id'] as string}>
              <TableCell
                colSpan={6}
                className="new-customized-table-data-row-cell"
                sx={{
                  padding: index === 0 ? '10px 0 2.5px 0' : '2.5px 0',
                }}
              >
                {renderRow(task)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Box>
);

export default TaskTable;
